import EditVoucher from "@/components/Vouchers/EditVoucher";

const EditVoucherPage = () => <EditVoucher />;

export default EditVoucherPage;
